export interface ProductoFactorImpacto{
    iddecinvproductofactorimpacto: number,
    iddecinvproyectoprodtermin: number,
    nombreindexacion: string,
    factorimpacto: string,
    cuartil: string,
    esprimerdecil: string
}

export function GetVoidProductoFactorImpacto():ProductoFactorImpacto{
    return {
        iddecinvproductofactorimpacto: 0,
        iddecinvproyectoprodtermin: 0,
        nombreindexacion: "",
        factorimpacto: "",
        cuartil: "",
        esprimerdecil: "N"
    }
}

export function SetProductoFactorImpacto(data: any):ProductoFactorImpacto{
    return {
        iddecinvproductofactorimpacto: data.iddecinvproductofactorimpacto??0,
        iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
        nombreindexacion: data.nombreindexacion??"",
        factorimpacto: data.factorimpacto??"",
        cuartil: data.cuartil??"",
        esprimerdecil: data.esprimerdecil??"N"
    }
}

export function SetListProductoFactorImpacto(data: Array<any>):Array<ProductoFactorImpacto>{
    let lista: Array<ProductoFactorImpacto> = []
    data.forEach(FI => {
        let index = SetProductoFactorImpacto(FI);
        lista.push(index);
    })
    //console.log(lista);
    return lista; 
}